import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

interface ContentMinHeightProps {
  children: ReactNode;
}

/**
 * Wraps content with a minimum height that fills the remaining viewport,
 * pushing the footer to the bottom when content is sparse.
 *
 * Heights are driven by the CSS custom properties published by
 * useBrightChromeObserver (called once at the app root), so this component
 * needs no observers, event listeners, or React state of its own.
 */
export const ContentMinHeight: React.FC<ContentMinHeightProps> = ({
  children,
}) => (
  <Box
    sx={{
      minHeight:
        'calc(100vh - var(--bright-header-height, 0px) - var(--bright-listing-header-height, 0px) - var(--bright-footer-height, 0px))',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {children}
  </Box>
);
